<template lang="pug">
  v-card
    v-card-title
     h2.card-title {{ 'base.edit_company' | translate }}
    v-card-content
      v-text-field(
        :focus="true"
        :label="$t('base.company_name_2')"
        v-model="form.name")
    v-card-actions
      v-btn.mr-2(
        @click="onSave"
        :loading="loading")
        | {{ 'base.save' | translate }}
</template>

<script>
import api from '@/api'

export default {
  name: 'CreateModal',

  props: {
    selected: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    form: {},
    loading: false
  }),

  mounted () {
    this.form = { ...this.selected }
  },

  methods: {
    async onSave () {
      this.loading = true
      const { id, ...payload } = this.form
      const { errors } = await api.companies.updateById(id, payload)
      this.loading = false
      if (!errors) {
        this.$emit('update')
        this.$emit('close')
      } else {
        this.$toasted.error(this.$t('errors.incorrect_data'))
      }
    }
  }
}
</script>
